import {AdminAnalyticsApi, IUserDrilldownResponse} from "../../../../api/AdminAnalyticsApi";

/**
 * Module-level cache for per-user drilldowns, keyed by lowercased email. Entries are only
 * valid for the current filter set, so the container clears it on filter change
 * (clearDrilldownCache) alongside the tab-data cache.
 */
const cache = new Map<string, IUserDrilldownResponse>();

export function clearDrilldownCache(): void {
    cache.clear();
}

export function getCachedUserDrilldown(email: string): IUserDrilldownResponse | undefined {
    return cache.get(email.toLowerCase());
}

export async function fetchUserDrilldown(
    email: string,
    startDate: string,
    endDate: string,
    country?: string,
): Promise<IUserDrilldownResponse | null> {
    const key = email.toLowerCase();
    const cached = cache.get(key);
    if (cached) return cached;
    const result = await AdminAnalyticsApi.getUserDrilldown(email, startDate, endDate, country);
    if (result.data) {
        cache.set(key, result.data);
        return result.data;
    }
    return null;
}
